import {CloseOutlined} from '@ant-design/icons';
import React, {useState} from 'react';

type StatusVariant = 'success' | 'warning' | 'error' | 'info';

interface StatusBannerProps {
  title?: string;
  message: React.ReactNode;
  variant?: StatusVariant;
}

const StatusBanner: React.FC<StatusBannerProps> = ({
  title = 'Status',
  message,
  variant = 'success'
}: StatusBannerProps) => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <div className={`status-banner status-${variant}`}>
      <div className="status-content">
        <div className="status-title">{title}</div>
        <div className="status-message">{message}</div>
      </div>
      <CloseOutlined
        onClick={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};

export default StatusBanner;
